import React, { Fragment } from "react";

import { Save as SaveIcon } from "react-feather";
import { Typography } from "@material-ui/core";

import { default as BaseModal } from "@ds-developer/modal";
import Button from "@ds-developer/button";

import { UnsavedChangedPromptModalProps } from "./types";

const UnsavedChangedPromptModal: React.FC<UnsavedChangedPromptModalProps> = ({
  onDiscardClick = () => {},
  onSaveClick = () => {},
  children,
}) => {
  const actions = (
    <Fragment>
      <Button
        onClick={onDiscardClick}
        variant="outlined"
        data-test="unsaved-changes-prompt-modal-discard-button"
      >
        Discard
      </Button>
      <Button
        onClick={onSaveClick}
        type="submit"
        variant="contained"
        color="secondary"
        startIcon={<SaveIcon size={16} />}
        data-test="unsaved-changes-prompt-modal-save-button"
      >
        Save changes
      </Button>
    </Fragment>
  );

  const modalContent = children ?? (
    <Typography>
      You have edited this page but haven’t saved it. Are you sure you want to
      discard your changes?
    </Typography>
  );

  return (
    <BaseModal
      actions={actions}
      open
      title="Unsaved changes to this page"
      data-test="unsaved-changes-prompt-modal"
    >
      {modalContent}
    </BaseModal>
  );
};

export default UnsavedChangedPromptModal;
